import { Translations } from '../translations.types';

export const nl: Translations = {
  flag: 'Vlag',
  shape: 'Vorm',
  'Population & Currency': 'Bevolking en Munteenheid',
  'Capital flag': 'Hoofdstad',
  emblem: 'Embleem',
  neighbours: 'Buren',
  placeholder: 'Land\u200b, gebied...',
  guess: 'Raden',
  share: 'Deel resultaten',
  'unknown-country': 'Onbekend land!',
  copy: 'Resultaten gekopieerd naar klembord',
  'daily-end': {
    'well-done': 'Goed gedaan!',
    'better-luck': 'Morgen meer geluk!',
    finished: 'Je hebt het spel van vandaag voltooid.',
    score: 'Score',
    'avg-guesses': 'Gem. pogingen',
    percentile: 'Percentiel',
    'share-score': 'Deel je score',
    replay: 'Opnieuw',
    results: 'Bekijk dagresultaat',
    summary: 'Samenvatting',
    attempts: 'Pogingen tonen',
  },
  modes: {
    'city-flags': {
      title: 'Stadsvlaggen',
      'drop-here': 'Sleep vlag hierheen',
      instruction: 'Sleep elke vlag naar de juiste stad',
      'ask-friend': 'Vraag een vriend',
      'play-now': 'Speel Stadsvlaggen',
      'share-question': 'Weet jij welke stad deze vlag voorstelt?',
      tray: 'Vlaggen',
      round: 'Ronde {{current}}/{{total}}',
      correct: 'Goed',
      wrong: 'Fout',
      check: 'Antwoorden controleren',
      continue: 'Volgende',
    },
    emblems: {
      title: 'Wapens',
      'drop-here': 'Sleep wapen hierheen',
      instruction: 'Sleep elk wapen naar het juiste land',
      'ask-friend': 'Vraag een vriend',
      'play-now': 'Speel Wapens',
      'share-question': 'Weet jij bij welk land dit wapen hoort?',
      tray: 'Wapens',
      round: 'Ronde {{current}}/{{total}}',
      correct: 'Goed',
      wrong: 'Fout',
      check: 'Antwoorden controleren',
      continue: 'Volgende',
    },
    accuracy: 'Nauwkeurigheid',
    'session-over': 'Sessie voltooid!',
    'play-again': 'Opnieuw spelen',
    'try-other': '{{mode}} proberen',
    'back-to-daily': 'Terug naar het dagelijkse spel',
    'load-failed': 'Kon de vragen niet laden. Probeer het later opnieuw.',
  },
  header: {
    menu: {
      title: 'Menu',
      play: 'Spelen',
      help: 'Help',
      open: 'Menu openen',
      close: 'Menu sluiten',
    },
    new: 'Nieuw',
    beta: 'Bèta',
    getPassport: 'Paspoort krijgen',
  },
  footer: {
    tagline: 'FLAGLE - Raad de vlag | Dagelijks aardrijkskundespel',
    madeBy: 'Gemaakt met ❤️ door Teuteuf',
  },
  sharing: {
    withFriends: 'Deel met vrienden',
    copyResult: 'Resultaat kopiëren',
    copyLink: 'Uitdagingslink kopiëren',
    linkCopied: 'Uitdagingslink gekopieerd naar klembord',
    copyFailed: 'Kopiëren mislukt — kopieer handmatig',
  },
  'play-bonus': 'Speel bonusronde',
  'next-bonus': 'Volgende bonusronde',
  'other-games': 'Onze andere spellen:',
  'submit-feedback': 'Feedback versturen',
  'remaining-guesses': 'Je hebt nog {{attemptsLeft}} pogingen',
  main: {
    'make-a-guess': 'Doe een gok om de eerste tegel te onthullen',
    country: 'Land...',
    flag: 'Vlag',
    'already-guessed': 'Je hebt al {{currentGuess}} geraden',
  },
  quiz: {
    title: 'Bevolking en Munteenheid',
    'estimated-population':
      'Wat is de geschatte bevolking van {{countryName}}?',
    'guess-currency': 'Welke munteenheid wordt gebruikt in {{countryName}}?',
    population: 'Bevolking',
    currency: 'Munteenheid',
    micro: {
      'less-25': 'Minder dan 25',
      over: 'Meer dan 2000',
    },
    small: {
      'first-option': '< 50 duizend',
      'second-option': '50 - 500 duizend',
      'third-option': '500k - 1 miljoen',
      'fourth-option': '1+ miljoen',
    },
    medium: {
      'first-option': '< 3 miljoen',
      'second-option': '3 - 5 miljoen',
      'third-option': '5 - 8 miljoen',
      'fourth-option': '8+ miljoen',
    },
    large: {
      'first-option': '< 15 miljoen',
      'second-option': '15 - 25 miljoen',
      'third-option': '25 - 35 miljoen',
      'fourth-option': '35+ miljoen',
    },
    massive: {
      'first-option': '< 60 miljoen',
      'second-option': '60 - 80 miljoen',
      'third-option': '80 - 100 miljoen',
      'fourth-option': '100+ miljoen',
    },
  },
  'shape-round': {
    title: 'Wat is de vorm van {{countryName}}',
    sponsored: 'Gesponsord door',
    like: 'Vind je deze ronde leuk?',
    try: 'Probeer het',
  },
  'capital-flag': {
    title: 'Kies de vlag van de hoofdstad van {{country}}: {{city}}',
  },
  'emblem-round': {
    title: 'Kies het nationale embleem van {{countryName}}',
  },
  border: {
    title: 'Kies de vlag van een buurland van {{countryName}}',
  },
  settings: {
    title: 'Instellingen',
    'distance-unit': 'Afstandseenheid',
    theme: 'Thema',
    language: 'Taal',
    'difficulty-modifiers': 'Moeilijkheidsaanpassingen',
    grayscale: 'Grijstinten vlag',
  },
  stats: {
    title: 'Statistieken',
    played: 'Gespeeld',
    win: 'Winstpercentage',
    currentStreak: 'Huidige reeks',
    maxStreak: 'Langste reeks',
    guessDistribution: 'Verdeling van pogingen',
    donate: '🇺🇦 Doneer aan Oekraïne ❤️',
  },
  'how-to-play': {
    title: 'Hoe te spelen',
    guess: 'Raad de',
    'number-guesses': 'in 6 pogingen.',
    'valid-country': 'Elke gok moet een geldig land of gebied zijn.',
    'after-guess':
      'Na elke gok zie je de afstand, richting en nabijheid van jouw gok tot de doelbestemming.',
    examples: 'Voorbeelden',
    'your-guess': 'Jouw gok',
    is: 'is',
    away: 'ver van de doelbestemming, het ligt in de noordoostelijke richting en je hebt slechts 32% nabijheid omdat het vrij ver weg is.',
    'second-guess': 'Je tweede gok',
    'getting-closer':
      'komt dichterbij! {{distance}} verwijderd, zuidoostelijke richting en 83% nabijheid!',
    'next-guess': 'Volgende gok,',
    'right-guess': 'het is de bestemming! Gefeliciteerd',
    'new-game': 'Een nieuw spel',
    available: 'is elke dag beschikbaar!',
    suggestions: 'Vragen of suggesties?',
    check: 'Bekijk de',
    faq: 'Flagle FAQ',
    privacy: 'Privacybeleid',
    manageConsent: 'Toestemming beheren',
    changePrivacySettings:
      'Je kunt je privacy-instellingen aanpassen door op de volgende knop te klikken:',
  },
  faq: {
    'when-new-game-available': {
      question: 'Wanneer is er een nieuw spel beschikbaar?',
      answer:
        'Elke dag is er om 0:00 uur lokale tijd van je apparaat een nieuw spel beschikbaar!',
    },
    'how-earn-bonus-round': {
      question: 'Hoe verdien ik toegang tot de volgende bonusronde?',
      answer:
        'Om de eerste bonusronde (vorm) te krijgen, hoef je alleen maar het juiste land te raden.',
    },
    'why-data-incorrect': {
      question: 'Waarom zijn je gegevens onjuist of verouderd?',
      answer:
        'We proberen onze gegevens zo snel en nauwkeurig mogelijk bij te werken. We weten dat grenzen veranderen, hoofdsteden verplaatsen en kaarten verouderen. Elke fout is volledig onbedoeld en vormt geen politieke uitspraak. We waarderen je feedback en zullen fouten corrigeren zodra we ervan horen. Na verloop van tijd zullen er steeds minder fouten te corrigeren zijn.',
    },
    'where-previous': {
      question: 'Waar vind ik eerdere Flagle-spellen?',
      answer:
        'Maak een Teuteuf Games-account aan en neem een Premium-lidmaatschap om toegang tot het archief te krijgen. Met het account kun je ook je statistieken opslaan en op meerdere apparaten spelen.',
    },
    'green-yellow-squares': {
      question: 'Wat betekenen de groene en gele vierkanten?',
      answer:
        'Ze komen overeen met het nabijheidspercentage:<br><br>• 🟩 = 20%<br>• 🟨 = 10%',
    },
    'proximity-percent': {
      question: 'Wat is het nabijheidspercentage?',
      answer:
        'Het is een andere manier om de afstand weer te geven.<br><br>Als je gok aan de andere kant van de wereld ligt, krijg je 0%.<br>Als het precies op het doelwit ligt, krijg je 100%!',
    },
    'how-distances-computed': {
      question: 'Hoe worden de afstanden berekend?',
      answer:
        'De weergegeven afstanden komen overeen met de afstanden tussen de centra van het geselecteerde gebied en het doelgebied.<br><br>Bijvoorbeeld, de berekende afstand tussen de Verenigde Staten en Canada is ongeveer 2260 km, zelfs als ze een gemeenschappelijke grens hebben.<br><br>Twee redenen voor deze keuze:<br><br>• Het is technisch veel eenvoudiger om de afstand op deze manier te berekenen dan met behulp van de dichtstbijzijnde grenzen.<br><br>• Je kunt informatie afleiden over de grootte van het doelland dankzij deze informatie.',
    },
    'why-not-valid-answer': {
      question: 'Waarom is een bepaald land geen geldige antwoord?',
      answer:
        'Ik gebruik de ISO 3166-1-standaard als referentie voor de lijst met landcodes.<br><br>Bijvoorbeeld, Schotland is geen geldig antwoord, omdat dit land volgens deze standaard deel uitmaakt van het Verenigd Koninkrijk.',
    },
    'how-countries-picked': {
      question:
        'Hoe worden landen en gebieden gekozen? Wat gebeurt er als alle landen zijn gekozen?',
      answer:
        'Elke dag wordt er willekeurig een land of gebied gekozen!<br><br>Dus het blijft elke dag willekeurig een kiezen, voor altijd!<br><br>Er zijn twee regels toegevoegd:<br><br>• Er wordt geen land of gebied van minder dan 5.000 km² gekozen als er in de afgelopen 7 dagen al een is gekozen.<br>• Er wordt geen land gekozen dat in de afgelopen 100 dagen al is gekozen.<br>• Er wordt geen land gekozen van hetzelfde continent als gisteren (dit geldt alleen voor Afrika en Azië).',
    },
    'why-ads': {
      question: 'Waarom zie ik advertenties op mijn apparaat?',
      answer:
        'We gebruiken advertenties om de ontwikkelingskosten voor nieuwe functies, hosting en andere uitgaven te dekken. In de loop der tijd heeft @teuteuf veel suggesties en verzoeken ontvangen die hij niet kon vervullen. We willen jou meer functies en een leukere spelervaring bieden. Ons plan is om een officiële mobiele app en talloze bonusfuncties te lanceren om Flagle het leukste geografiequiz-spel op internet te houden!',
    },
  },
  account: {
    title: 'Rekening',
    loggedIn: {
      hi: 'Hoi',
      text: 'We slaan nu je statistieken op na elk spel. Dit stelt niet alleen je voortgang veilig, maar zorgt ook voor een naadloze gameplay op meerdere apparaten.',
      learnMore: 'Kom meer te weten',
      signOut: 'Afmelden',
      manageAccount: 'Beheer account',
      premiumLabel: 'Teuteuf Passport',
    },
    loggedOut: {
      text: 'Meld u aan voor een Teuteuf Games-account of log in om uw spelstatistieken op te slaan en op meerdere apparaten te spelen. Alle voordelen weten?',
      discoverMoreHere: 'Ontdek hier meer',
      signUp: 'Aanmelden',
      login: 'Log in',
      loginWith: 'Inloggen met {{platform}}',
    },
  },
  member: {
    becomeMember: 'Word Teuteuf Premium-lid',
    noAds: 'Geen advertenties',
    replayGames: 'Spellen opnieuw spelen',
    playArchive: 'Speel het archief',
    dedicatedSupport: 'Toegewijde support',
    signUp: 'Meld je nu aan',
  },
  archive: {
    archive: 'Archief',
    archiveMode: 'Archiefmodus',
    returnToToday: 'Terug naar het spel van vandaag',
    playArchive: 'Archief spelen',
    accessArchive:
      'Toegang tot het spelarchief is exclusief voor Passport leden. Registreer via de onderstaande link en speel elk spel dat ooit is verschenen!',
    gamesSince:
      'Hier staan alle Flagle-spellen sinds {{date}}. Klik op een spel om die dag te spelen.',
    playRandom: 'Speel een willekeurig spel',
    wantToPlayPrevious: 'Wil je eerdere spellen van FLAGLE spelen?',
    replayTodaysGame: 'Vandaag opnieuw spelen',
    replayGame: 'Spel opnieuw spelen',
    replayGames: 'Spellen opnieuw spelen',
    accessReplay:
      'Spellen opnieuw spelen is een exclusieve functie voor Passport leden. Meld je aan via de link hieronder en ontgrendel alle spellen die ooit hebben bestaan!',
  },
  commonPhrases: {
    removeAds: 'Advertenties verwijderen',
  },
};
